<template>
  <!-- Breadcrumb -->
  <div class="tw-p-2 tw-bg-white tw-w-full tw-border tw-border-solid tw-flex tw-items-center tw-gap-2">
    <router-link :to="{ name: 'pages.admin.dashboard' }"
      class="tw-text-gray-400 tw-duration-200 hover:tw-text-gray-700 tw-text-xl tw-flex tw-items-center tw-gap-2">
      <icon icon="solar:home-smile-bold-duotone" />
      <span class="tw-text-sm">{{ $t("dashboard.sidebar.dashboard") }}</span>
    </router-link>
    <span class="tw-text-gray-300">/</span>
    <button disabled class="tw-text-primary-500 tw-text-xl tw-flex tw-items-center tw-gap-2">
      <span class="tw-text-sm">{{ $t("dashboard.sidebar.subscriptions", "Subscriptions") }}</span>
    </button>
  </div>

  <!-- Tabs container (same structure as the Settings page) -->
  <div class="tw-h-full">
    <div class="tw-w-full tw-h-full">
      <div class="tw-w-full tw-my-4 tw-px-5">
        <ul class="tw-flex tw-gap-5 tw-border-b">
          <li v-for="t in tabs" :key="t.key" @click="tab = t.key"
            :class="[tab == t.key ? '!tw-border-b-2 !tw-border-primary-500' : 'tw-border-b-2 tw-border-transparent']"
            class="tw-text-sm tw-pb-2 tw-font-semibold tw-border-b-2 tw-border-transparent tw-w-fit tw-duration-200 tw-cursor-pointer hover:tw-text-gray-600 tw-flex tw-items-center tw-gap-2">
            <icon :icon="t.icon" :class="tab == t.key ? 'tw-text-primary-500' : 'tw-text-gray-500'" />
            {{ $t(t.name, t.fallback) }}
          </li>
        </ul>
      </div>
    </div>

    <div class="tw-w-full tw-overflow-hidden">
      <transition class="tw-duration-200" enter-from-class="tw-opacity-0 tw-translate-x-[10px]"
        leave-to-class="tw-opacity-0 -tw-translate-x-[10px]" mode="out-in">
        <div class="tw-px-4 tw-pb-6">
          <component :is="activeComponent" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import SettingsTab from './partials/SettingsTab.vue';
import PlansTab from './partials/PlansTab.vue';
import UsersTab from './partials/UsersTab.vue';
import LogsTab from './partials/LogsTab.vue';

const tabs = [
  { key: 'settings', name: 'subscriptions.tabs.settings', fallback: 'Settings', icon: 'solar:settings-bold-duotone', component: SettingsTab },
  { key: 'plans', name: 'subscriptions.tabs.plans', fallback: 'Plans', icon: 'solar:tag-price-bold-duotone', component: PlansTab },
  { key: 'users', name: 'subscriptions.tabs.users', fallback: 'User subscriptions', icon: 'solar:users-group-rounded-bold-duotone', component: UsersTab },
  { key: 'logs', name: 'subscriptions.tabs.logs', fallback: 'Webhook logs', icon: 'solar:clipboard-list-bold-duotone', component: LogsTab },
];

const tab = ref('settings');
const activeComponent = computed(() => tabs.find(t => t.key === tab.value)?.component);
</script>

<style></style>
